import React, { forwardRef, useEffect, useMemo, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import classes from './Tooltip.module.css'
import classNames from 'classnames'

const getTooltipRoot = () => {
    let root = document.getElementById('tooltip-root')
    if (!root) {
        root = document.createElement('div')
        root.setAttribute('id', 'tooltip-root')
        root.style.position = 'unset'
        document.body.appendChild(root)
    }
    return root
}

const TooltipWrapper = ({ children, tooltip }) => {
    let wrapperDiv = useRef()

    const [tooltipPosition, setPosition] = useState({
        x: 'unset',
        y: 'unset',
    })

    const [tooltipShowing, setShowing] = useState(false)

    const onMouseEnter = event => {
        const newPosition = {}
        const tooltipWidth = wrapperDiv.current.offsetWidth
        const mousePositionX = event.screenX
        if (mousePositionX + tooltipWidth < window.innerWidth) {
            newPosition.x = mousePositionX
        } else {
            newPosition.x = mousePositionX - tooltipWidth
        }

        const mousePositionY = event.screenY + window.scrollY
        const tooltipHeight = wrapperDiv.current.offsetHeight
        if (
            mousePositionY + tooltipHeight <
            window.innerHeight + window.scrollY
        ) {
            newPosition.y = mousePositionY
        } else {
            newPosition.y = window.innerHeight + window.scrollY - tooltipHeight
            // newPosition.y = mousePositionY - tooltipHeight
        }

        setPosition(newPosition)
        setShowing(true)
    }

    const onMouseLeave = () => {
        setShowing(false)
        setTimeout(() => {
            setPosition({
                x: 'unset',
                y: 'unset',
            })
        }, 500)
    }

    return (
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            {children}
            <Tooltip
                ref={wrapperDiv}
                {...tooltipPosition}
                showing={tooltipShowing}
                setShowing={setShowing}
            >
                {tooltip}
            </Tooltip>
        </div>
    )
}

const Tooltip = forwardRef(({ children, x, y, showing, setShowing }, ref) => {
    const tooltipRoot = useMemo(() => getTooltipRoot(), [])

    const content = (
        <div
            ref={ref}
            className={classNames(
                classes.tooltip,
                showing && classes.tooltipShowing
            )}
            style={{
                left: x,
                top: y,
            }}
            onMouseEnter={() => setShowing(true)}
        >
            {children}
        </div>
    )

    return createPortal(content, tooltipRoot)
})

export default TooltipWrapper
